import TimeTrigger from './trigger.ui';

const { PauseTrigger, OverlayTrigger, JumpTrigger } = TimeTrigger;

export { PauseTrigger, OverlayTrigger, JumpTrigger };
